import Vue from 'vue'
import { Button,
        Form,
        FormItem, 
        Input, 
        Checkbox,
        CheckboxGroup,
        CheckboxButton,
        Message, 
        Container, 
        Header, 
        Aside, 
        Main, 
        Menu, 
        Submenu, 
        MenuItemGroup, 
        MenuItem,
        Card,
        Tabs,
        TabPane,
        Table,
        TableColumn,
        Pagination,
        Row,
        Col,
        Divider,
        Tooltip,
        Dialog,
        Timeline,
        TimelineItem,
        DatePicker,
        Cascader,
        Select,
        Option,
        Breadcrumb,
        BreadcrumbItem,
        Tag,
        Upload,
        TimePicker,
        Loading,
        Radio,
        RadioGroup,
        MessageBox,
        Carousel,
        Badge,
        CarouselItem,
     } from 'element-ui'

Vue.use(Button)
Vue.use(Badge)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Col)
Vue.use(Divider)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(Select)
Vue.use(Option)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tag)
Vue.use(Upload)
Vue.use(TimePicker)
Vue.use(Loading)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$message = Message
Vue.prototype.$MessageBox = MessageBox
